import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { faqs, siteInfo } from "@/mocks/gossip";
import Hero from "./components/Hero";
import HotSearch from "./components/HotSearch";
import FeaturedMelons from "./components/FeaturedMelons";
import CategoryGrid from "./components/CategoryGrid";
import FollowTimeline from "./components/FollowTimeline";
import FaqSection from "./components/FaqSection";
import Testimonials from "./components/Testimonials";

const SITE_URL = "https://pjdflq.cn";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "瓜田吃瓜",
    url: `${SITE_URL}/`,
    description:
      "吃瓜群众集合地，围观娱乐圈八卦、影视综艺爆点与社会热点，蹲后续、看反转、追实锤。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/plaza?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "瓜田吃瓜",
    url: `${SITE_URL}/`,
    email: siteInfo.email,
    description: siteInfo.intro,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  },
];

export default function Home() {
  useDocumentMeta({
    title: "瓜田吃瓜 - 吃瓜群众集合地，蹲后续爆点不迷路",
    description:
      "瓜田吃瓜是吃瓜群众的聚集地，第一时间围观娱乐圈八卦、影视综艺爆点与社会热点。蹲后续、看反转、追实锤，围观现场站队不迷路。",
    keywords: "瓜田吃瓜,吃瓜群众,蹲后续,娱乐八卦,社会热点",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <SiteHeader />
      <main>
        <Hero />
        <HotSearch />
        <FeaturedMelons />
        <CategoryGrid />
        <FollowTimeline />
        <FaqSection />
        <Testimonials />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}